module.exports = __webpack_public_path__ + "img/1.8b64f1c1.png";